/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/no-array-index-key */
import { useEffect } from "react";
import styled, { createGlobalStyle } from "styled-components";
import useTrackWebSession from "hooks/useTrackWebSession";
import SeoLayout from "../components/seoLayout";
import { Section, Container, Row } from "../styles/commonStyles";
import Data from "../data/marketingPagesFromExcelSheet.json";
import JobCategoriesData from "../data/marketingPagesFromExcelSheetMainJobCategories.json";
import Mixpanel from "../utils/Mixpanel";
import { getUrlPath } from "../utils/helpers";
import ResponsiveFooter from "../components/ResponsiveFooter";
import TagManagerUtils from "../utils/TagManager";

const GlobalStyle = createGlobalStyle`
    header::before {
        content: " ";
        position: absolute;
        width: 100%;
        height: 90px;
        z-index: -1;
        top: 0;
        left: 0;
        background-color: #4d3951;
        
    }
    #cta-banner-mobile-view {
        display: none !important;
    }
`;

const SitemapPage = () => {
	const employerJobs = Data.data.allDataForLinksOnSitemapXlsxWhereDoWeHaveJobs.edges;
	const employeeJobs = Data.data.allDataForLinksOnSitemapXlsxWhereDoWeHaveUsers.edges;
	const jobCategories =
		JobCategoriesData.data.allDataForLinksOnSitemapXlsxJobCategories.edges;
	const employerJobsSheet4 = Data.data.allDataForLinksOnSitemapXlsxSheet4.edges;

	const pageName = "Sitemamp";
	useTrackWebSession(pageName);
	useEffect(() => {
		Mixpanel.track("Page View", {
			"Page URL": typeof window !== "undefined" && window.location.href,
			Source: pageName,
			page: getUrlPath(),
		});

		TagManagerUtils.addDataLayer({
			Source: pageName,
		});
	}, []);

	const trackHirePageClick = (data) => {
		Mixpanel.track("Hire page click", {
			Source: "Sitemap",
			job: data?.node?.Job_Type,
			area: data?.node?.Area,
			page: getUrlPath(),
		});
	};

	const trackFindJobsClick = (data) => {
		Mixpanel.track("Hire page click", {
			Source: "Sitemap",
			area: data?.node?.Area,
			page: getUrlPath(),
		});
	};

	return (
		<SeoLayout pageName={pageName}>
			<GlobalStyle />

			<Section>
				<Container>
					<SitemapRow>
						<SitemapDataSection>
							<SectionHeading>Post Jobs in Mumbai</SectionHeading>
							<SectionContent>
								<SectionContentWrapper>
									{employerJobs &&
										employerJobs.map((data, index) => (
											<SectionContentLink
												key={index}
												rel="nofollow"
												href={`/hire/${data?.node?.URL}`}
												onClick={() => trackHirePageClick(data)}
											>{`Hire ${data?.node?.Job_Type} in ${data?.node?.Area}`}</SectionContentLink>
										))}
								</SectionContentWrapper>
							</SectionContent>
							<SectionContent>
								<SectionContentWrapper>
									{employerJobsSheet4 &&
										employerJobsSheet4.map((data, index) => (
											<SectionContentLink
												key={index}
												rel="nofollow"
												href={`/hire/${data?.node?.URL}`}
												onClick={() => trackHirePageClick(data)}
											>{`Hire ${data?.node?.Job_Category} in ${data?.node?.Area}`}</SectionContentLink>
										))}
								</SectionContentWrapper>
							</SectionContent>
							<SectionContent>
								<SectionContentWrapper>
									{jobCategories &&
										jobCategories.map((data, index) => (
											<SectionContentLink
												key={index}
												rel="nofollow"
												href={`/hire/${data?.node?.URL}`}
												onClick={() => trackHirePageClick(data)}
											>{`Hire ${data?.node?.Job_Category} in ${data?.node?.Area}`}</SectionContentLink>
										))}
								</SectionContentWrapper>
							</SectionContent>
						</SitemapDataSection>
					</SitemapRow>
				</Container>
			</Section>

			<Section>
				<Container>
					<SitemapRow>
						<SitemapDataSection>
							<SectionHeading>Find Jobs in Mumbai</SectionHeading>
							<SectionContent>
								<SectionContentWrapper>
									{employeeJobs &&
										employeeJobs.map((data, index) => (
											<SectionContentLink
												key={index}
												rel="nofollow"
												href={`/jobs/${data?.node?.URL}`}
												onClick={() => trackFindJobsClick(data)}
											>{`Find Jobs in ${data?.node?.Area}`}</SectionContentLink>
										))}
								</SectionContentWrapper>
							</SectionContent>
						</SitemapDataSection>
					</SitemapRow>
				</Container>
			</Section>

			<ResponsiveFooter />
		</SeoLayout>
	);
};

// Styles
const SitemapRow = styled(Row)`
	display: block;
	margin-bottom: 50px;
`;
const SitemapDataSection = styled.div`
	border-bottom: 1px solid #eee;
	padding-bottom: 50px;
`;
const SectionHeading = styled.h3``;
const SectionContent = styled.div``;
const SectionContentWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(265px, 1fr));
	column-gap: 16px;
	row-gap: 8px;
`;

const SectionContentLink = styled.a`
	color: #6a6a6a;
	text-decoration: none;
	font-size: 15px;

	&:hover,
	&:active,
	&:focus {
		color: #2bb793;
	}

	&:visited {
		color: #428a77;
	}
`;

export default SitemapPage;
